import { render, staticRenderFns } from "./QueriesMenu.vue?vue&type=template&id=1a625da5&scoped=true"
import script from "./QueriesMenu.vue?vue&type=script&lang=ts"
export * from "./QueriesMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a625da5",
  null
  
)

export default component.exports